/**
 * LegalDocumentItemType enum
 * Identifies a row on the Legal Documents screen.
 * Matches Flutter implementation: lib/domain/entity/legal/legal_document_item.dart
 */
export enum LegalDocumentItemType {
    terms = 0,
    coinsPolicy = 1,
    rewardsPolicy = 2,
    exclusiveSubscriptionsPolicy = 3,
    premiumSubscriptionsPolicy = 4,
    privacyPolicy = 5,
    communityGuidelines = 6,
}
